import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Icon(props) {
  var children = props.children,
      className = props.className,
      name = props.name,
      size = props.size,
      indentLeft = props.indentLeft,
      indentRight = props.indentRight,
      color = props.color,
      animation = props.animation,
      rotation = props.rotation,
      flipHorizontal = props.flipHorizontal,
      flipVertical = props.flipVertical,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "name", "size", "indentLeft", "indentRight", "color", "animation", "rotation", "flipHorizontal", "flipVertical"]);

  var classes = classNames(className, 'o2-icon', name ? "o2-icon--" + name : false, size ? "o2-icon--" + size : false, color ? "o2-icon--color-" + color : false, animation ? "o2-icon--" + animation : false, rotation ? "o2-icon--rotate-" + rotation : false, {
    "o2-icon--indent-left": indentLeft,
    "o2-icon--indent-right": indentRight,
    "o2-icon--flip-horizontal": flipHorizontal,
    "o2-icon--flip-vertical": flipVertical
  });
  return /*#__PURE__*/React.createElement("span", _extends({}, attributes, {
    className: classes
  }), children);
}

O2Icon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  color: PropTypes.oneOf(["pdf", "xls", "doc", "facebook", "twitter", "white", "black", "brand", "success", "warning", "danger", "internal", "price"]),
  animation: PropTypes.oneOf(['spin', 'pulse']),
  rotation: PropTypes.oneOf(['90', '180', '270']),
  flipHorizontal: PropTypes.bool,
  flipVertical: PropTypes.bool
};
export default O2Icon;